import React, {Component} from 'react';
import AdminTabs from './AdminTabs';
import {DataTable} from "react-data-components";
import userImage from '../../assets/128x128.jpg';
import api from '../../utils/api';
import moment from 'moment';
import {emojify} from 'react-emojione';
import 'emojione-picker/css/picker.css';

import Linkify from 'linkifyjs/react';
import jwt from 'jsonwebtoken';


function buildTable(data, columns) {
  const renderMapUrl =
    (val, row) =>
      <a href={`https://www.google.com/maps?q=${row['lat']},${row['long']}`}>
        Google Maps
      </a>;

  return (
    <DataTable
        keys="name"
        className="table-striped"
        columns={columns}
        initialData={data}
        useShowHideColumns={true}
        initialPageLength={10}
        initialSortBy={{ prop: 'name', order: 'descending' }}
        pageLengthOptions={[10, 25, 50, 100]}
    />
  );
}



class AdminInstructorView extends Component {
    
    
    constructor(props){
        super(props);
        
        this.state = {
            loaded: false,
            rowContent: null
        }
    }
    
    
    renderName = (val, row) => {

        
        
            let profile = row;
            
            if(profile){
            let avatar = userImage;
            if(profile.image){
                if(profile.image.indexOf('http') > -1){
                    avatar = profile.image;
                }else{
                    avatar = api.makeFileURL(profile.image, this.props.user.id);
                }
            }
        
        
            return (
                <span onClick={e => {
                    e.preventDefault();
                    //this.setState({rowContent: row});
                }}>
                    <div className="user-and-question">
                        <div className="uq-avatar-wrap"><img src={avatar} alt="User Image" /> </div>
                        <div>
                            <h3>{`${profile.name} ${profile.lname}`}</h3>
                            <p>{profile.role}</p>
                        </div>
                    </div>
                </span>
            )
            }
    }
    

    
    
    renderDate = (val, row) => {
        return (
            <span>
                {moment(row.createdAt).format('MMM DD YYYY [at] hh:mm A')}  
            </span>
        )
    }
    
    renderType = (val, row) => {
        return (
            <span>{row.type.split('/')[1]}
            </span>
        )
    }
    
    renderKind = (val, row) => {
        return (
            <span>{row.Messages.length}
            </span>
        )
    }
    
    renderResponses = (val, row) => {
        return (
            <span>{row.Messages.length}
            </span>
        )
    }
    
    renderResponseTime = (val, row) => {
        let dur = 0;
        row.threads.map(t => {
            if(t.Messages){
                let first = moment(t.createdAt);
                let response = moment(t.Messages[0].createdAt);
                dur += response.diff(first, 'seconds');
            }
            return true;
        })
        
        return (
            <span>
                {moment.duration(dur / row.threads.length).humanize()}
            </span>
            )
    }
    
    renderFlagged = (val, row) => {
        return (
            <span>{row.Messages.filter(m => m.reportedBy && m.reportedBy.length > 0).length}
            </span>
        )
    }
    
    renderStatus = (val, row) => {
        return (
            <span>
            
                <a href="#" onClick={e => {
                    e.preventDefault();
                     let command = jwt.sign({
                        command: {
                            type: 'DELETE_ATTACHMENT',
                            fileId: row.id,
                            token: this.props.user.id
                        }}, '#&r7%+UbWU8Hc');
                        if(this.props.socket){
                            this.props.socket.send(command);
                        } 
                }} data-toggle="tooltip" title="" className="btn btn-icon btn-default" data-original-title="Delete Attachment"><i className="zmdi zmdi-close"></i> </a>
                <a href={api.makeFileURL(row.url, this.props.user.id)} target="_blank" data-toggle="tooltip" title="" className="btn btn-icon btn-default" data-original-title="Download Attachment"><i className="zmdi zmdi-save"></i> </a>
                {row.Message.Thread &&
                <a href={`/chat/${row.Message.Thread.id}`} data-toggle="tooltip" title="" className="btn btn-icon btn-default" data-original-title="Go to chat location"><i className="zmdi zmdi-arrow-right"></i> </a>
                }
            </span>
        )
        
    }
    
    componentDidMount = () => {
        let command = jwt.sign({
            command: {
                type: 'GET_INSTRUCTORS',
                profileId: this.props.user.user.Profile.id,
                token: this.props.user.id
            }}, '#&r7%+UbWU8Hc');
            if(this.props.socket.readyState){
                this.props.socket.send(command);
            }
    }
    
    componentDidUpdate = (props) => {
        if(this.props.socket.readyState && !this.state.loaded){
            
            this.setState({loaded: true}, () => {
                let command = jwt.sign({
                    command: {
                        type: 'GET_INSTRUCTORS',
                        profileId: this.props.user.user.Profile.id,
                        token: this.props.user.id
                    }}, '#&r7%+UbWU8Hc');
                    
                    if(this.props.socket.readyState){
                        this.props.socket.send(command);
                    }
            })
            
            
            
        }
        
        if(props.flaggedComments !== this.props.flaggedComments){
            //buildTable(this.props.flaggedComments);
        }
        
    }
    
    render(){
        
        const columns = [
                            {title: 'Instructor Name', prop: 'id', className: 'v-middle', render: this.renderName},
                            {title: 'Responses', prop: 'Messages', className: 'v-middle', render: this.renderResponses},
                            {title: 'Resolved', prop: 'solved', className: 'v-middle'},

                            {title: 'Avg. Response Time', prop: 'id', className: 'v-middle', render: this.renderResponseTime},
                            
                            {title: 'Flagged Responses', prop: 'id', className: 'v-middle', render: this.renderFlagged},

                        ];
                        
        let {rowContent} = this.state;
        let splitLines = [];
        if(rowContent){
            splitLines = rowContent.content.split('\n').filter(l => l !== '');
        }
        
         const linkOptions = {
            target: '_blank'
        }
        
        return (
            <div className="chat-box">
                <AdminTabs view="instructors" />
                <div className="chat-contents-wrapper" style={{background: '#111', paddingBottom: '50px'}}>
                    <div className="sp-top10" style={{paddingLeft: "20px", overflowY: "scroll", position: "relative", height: "100%", paddingRight: "20px"}}>
                       
                        <h2 className="font-22 text-white font-300 sm-bottom30">Instructors</h2>
                        


                        <div className="tickets-table">
                                    {this.props.adminInstructors.length > 0 &&
                                    
                                        buildTable(this.props.adminInstructors, columns)
                                    }
                                </div>
                                    
                    </div>
                </div>
                
                
                <div className="modal fade in" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" style={{zIndex: 9999, display: (this.state.rowContent) ? 'block' : 'none'}}>
                    <div className="modal-dialog modal-lg" role="document">

                        <div className="modal-content">

                            <div className="modal-body no-padding" style={{background: "#3c3840"}}>
                                <div className="clearfix">
                                    <div>
                                        <div className="modal-header">
                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                                            <h4 className="modal-title" id="myModalLabel">Reported Comment</h4>
                                        </div>
                                        <div className="modal-body no-padding subjectDeadlineContainer">
                                            
                                            <div className="chat-item chat-item-left modal-chat-item">
                                                <div className="chat-item-content">
                                                    {rowContent ?
                                                        
                                                        rowContent.Profile.image && rowContent.Profile.image.indexOf('http') > -1 ?
                                                        <img src={rowContent.Profile.image} className="chat-avatar" alt="User Image" />
                                                    :
                                                        rowContent.Profile.image && rowContent.Profile.image.indexOf('http') === -1 ?
                                                            <img src={api.makeFileURL(rowContent.Profile.image, this.props.user.id)} className="chat-avatar" alt="User Image" />
                                                        :
                                                        <img src={userImage} className="chat-avatar" alt="User Image" />
                                                        
                                                        :
                                                        null
                                                    }
                                                    <div className="chat-box-wrap">
                                                        <div className="chat-box-wrapper">
                                                            {splitLines.map(l => {
                                                                return (
                                                                    <Linkify tagName="p" options={linkOptions}>{emojify(l.replace('{name}', rowContent.Profile.name), {output: 'unicode'})}</Linkify>    
                                                                )
                                                            })
                                                            }
                                                            {rowContent && 
                                                                rowContent.reportedBy &&
                                                                    rowContent.reportedBy.length > 0 &&
                                                                    rowContent.reportedBy[0].status !== 'Pending' &&
                                                                <span className="chat-box-meta">
                                                                    <span>{rowContent.Profile.name} - {rowContent.Profile.role}</span>
                                                                    <span>{moment(rowContent.createdAt).fromNow()}</span>
                                                                </span>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>


                                       
                                    </div>
                                   

                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-default" onClick={e => {
                                    e.preventDefault();
                                    this.setState({rowContent: null}, () => {
                                    
                                    let command = jwt.sign({
                                        command: {
                                            type: 'RESPOND_TO_REPORT',
                                            messageId: rowContent.id,
                                            response: 'keep',
                                            profileId: this.props.user.user.Profile.id,
                                            token: this.props.user.id
                                        }}, '#&r7%+UbWU8Hc');
                                        
                                        this.props.socket.send(command);
                                    });
                                    
                                }}>Keep</button>
                                <button type="button" onClick={e => {
                                    e.preventDefault();
                                    this.setState({rowContent: null}, () => {
                                    
                                    let command = jwt.sign({
                                        command: {
                                            type: 'RESPOND_TO_REPORT',
                                            messageId: rowContent.id,
                                            response: 'delete',
                                            profileId: this.props.user.user.Profile.id,
                                            token: this.props.user.id
                                        }}, '#&r7%+UbWU8Hc');
                                        
                                        this.props.socket.send(command);
                                    });
                                    
                                }} className="btn btn-danger">Delete Comment</button>
                            </div>
                        </div>

                    </div>
                </div>
           
            
            </div>
            )
    }
}

export default AdminInstructorView;


// WEBPACK FOOTER //
// ./src/components/Chat/AdminInstructorView.js